export default "__VITE_ASSET__XoKjlVLG__"